<div class="customer-filter">
  <button
    type="button"
    class="btn btn--small btn--blue customer-filter__button"
    (click)="openDialog()"
  >
    {{ buttonLabel }}
  </button>

  <div *ngIf="currentConditionsLabel" class="customer-filter__conditions">
    {{ currentConditionsLabel }}
  </div>
</div>
